<template>
    <div class="w-full md:w-4/5 m-auto py-6 px-12">
        <div class="bg-white bg-gray-100 border px-2 py-2 mt-1 pb-6">
            <div class="px-4 bg-gray-100">
                <div>
                    <div class="p-8 -mb-8">
                        <h1 class="mb-8 font-bold text-3xl">Forgot Password</h1>
                    </div>
                    <div id="personal_details_content"
                         class="bg-white border border-t-0 border-gray-300 overflow-hidden"
                    >
                        <div>
                            <h2 class="mb-3 mt-4 pl-8 font-bold text-2xl">Forgot Password Form</h2>
                            <p class="text-left pl-8 pr-8">
                                In order to reset the password, you must first fill in the following form. In doing so, a link to
                                reset your password will be generated and sent to the email provided. To proceed, check your emails and follow the link.
                            </p>
                            <form id="smmr-form" @submit.prevent="update">
                                <div class="p-8 pb-2 flex flex-wrap" @change="dirtyForm()">
                                    <text-input v-model="form.email" class="pr-6" :width="'full'" label="Email" @update:modelValue="value = $event" />
                                    <text-input v-model="form.email_confirmation" :width="'full'" class="pr-6" label="Confirm Email"
                                                @update:modelValue="value = $event"
                                    />
                                </div>
                                <div v-if="successMessage" class="success-message m-8 w-auto">{{ successMessage }}</div>
                                <div v-if="serverErrors" class="m-8 server-error">
                                    <div v-for="(value, key) in serverErrors" :key="key">
                                        {{ value[0] }}
                                    </div>
                                </div>
                                <div class="lg:flex justify-end w-full pb-2 -mt-8">
                                    <div class="relative w-auto lg:w-1/3 mx-8">
                                        <application-component-save-button :disabled="formDirty"
                                                                           class="w-full flex btn-green ml-auto mt-8 md:inline-block text-center"
                                                                           type="submit"
                                        >
                                            Send forgot password request
                                            <div v-if="loading" class="lds-ring-container absolute top-10">
                                                <div class="lds-ring">
                                                    <div />
                                                    <div />
                                                    <div />
                                                    <div />
                                                </div>
                                            </div>
                                        </application-component-save-button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TextInput from '../../shared/TextInput'
import ApplicationComponentSaveButton from '@/shared/ApplicationComponentSaveButton'

export default {
    name: 'ForgotPassword',
    components: {
        TextInput,
        ApplicationComponentSaveButton,
    },
    metaInfo: {title: 'Forgot Password'},

    data() {
        return {
            form: ({
                email: null,
                email_confirmation: null,
            }),

            formDirty: false,
            loading: false,
            successMessage: '',
            serverErrors: '',
        }
    },
    created() {
        this.loadPage()
    },
    methods: {
        update() {
            this.loading = true
            this.$store.dispatch('forgotPassword', {
                forgotPasswordData: this.form,
            })
                .then((response) => {
                    this.loading = false
                    this.serverErrors = ''
                    this.successMessage = response.data
                })
                .catch(error => {
                    this.loading = false
                    this.serverErrors = Object.values(error.response.data.errors)
                    this.successMessage = ''
                })
            this.formDirty = false
        },
        dirtyForm() {
            this.formDirty = true
            this.successMessage = ''
        },
        loadPage() {
        },
    },
}
</script>


